import React from 'react';
import SalesAchievementFilter from './SalesAchievementFilter';
import CustomerBalanceFilter from './CustomerBalanceFilter';
import SalesListDetailFilter from './SalesListDetailFilter';
import SalesByServiceItemFilter from './SalesByServiceItemFilter';

const FilterOffcanvas = ({
    activeTab,
    filters,
    customerBalanceFilters,
    salesListDetailFilters,
    salesByServiceFilters,
    handleFilterChange,
    handleCustomerBalanceFilterChange,
    handleSalesListDetailFilterChange,
    handleSalesByServiceFilterChange,
    handleResetFilter,
    handleApplyFilter,
    periodOptions,
    userOptions,
    cascadedUserOptions,
    serviceOptions,
    productCategoryOptions,
    standardOptions,
    departmentOptions,
    paymentOptions,
    statusOptions,
    serviceItemOptions,
    salesCreatorOptions, // Keep for backward compatibility with other tabs
    branchOptions,
    taggingOptions,
    canViewGlobal,
    canViewDepartment,
    canViewOwn,
    user
}) => {
    return (
        <div className="offcanvas offcanvas-end" tabIndex="-1" id="offcanvasEnd" aria-labelledby="offcanvasEndLabel">
            <div className="offcanvas-header">
                <h2 className="offcanvas-title" id="offcanvasEndLabel">Filter</h2>
                <button type="button" className="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
            </div>
            <div className="offcanvas-body">
                {/* Sales Achievement Filter */}
                {activeTab === 'sales-achievement' && (
                    <SalesAchievementFilter
                        filters={filters}
                        handleFilterChange={handleFilterChange}
                        periodOptions={periodOptions}
                        userOptions={cascadedUserOptions || userOptions}
                        serviceOptions={serviceOptions}
                        productCategoryOptions={productCategoryOptions}
                        standardOptions={standardOptions}
                        departmentOptions={departmentOptions}
                        branchOptions={branchOptions}
                        taggingOptions={taggingOptions}
                        canViewGlobal={canViewGlobal}
                        canViewDepartment={canViewDepartment}
                        canViewOwn={canViewOwn}
                        user={user}
                    />
                )}

                {/* Sales by Service Item Filter */}
                {activeTab === 'sales-by-service' && (
                    <SalesByServiceItemFilter
                        filters={salesByServiceFilters}
                        handleFilterChange={handleSalesByServiceFilterChange}
                        periodOptions={periodOptions}
                        salesCreatorOptions={salesCreatorOptions}
                        serviceOptions={serviceOptions}
                        productCategoryOptions={productCategoryOptions}
                        standardOptions={standardOptions}
                        departmentOptions={departmentOptions}
                        branchOptions={branchOptions}
                        taggingOptions={taggingOptions}
                        canViewGlobal={canViewGlobal}
                        canViewDepartment={canViewDepartment}
                        canViewOwn={canViewOwn}
                        user={user}
                    />
                )}

                {/* Total Revenue: same filters as Sales Achievement (single set; API merges into total-revenue query) */}
                {activeTab === 'total-revenue' && (
                    <SalesAchievementFilter
                        filters={filters}
                        handleFilterChange={handleFilterChange}
                        periodOptions={periodOptions}
                        userOptions={cascadedUserOptions || userOptions}
                        serviceOptions={serviceOptions}
                        productCategoryOptions={productCategoryOptions}
                        standardOptions={standardOptions}
                        departmentOptions={departmentOptions}
                        branchOptions={branchOptions}
                        taggingOptions={taggingOptions}
                        canViewGlobal={canViewGlobal}
                        canViewDepartment={canViewDepartment}
                        canViewOwn={canViewOwn}
                        user={user}
                    />
                )}

                {/* Contract Won: same filters as Total Revenue */}
                {activeTab === 'total-contract-won' && (
                    <SalesAchievementFilter
                        filters={filters}
                        handleFilterChange={handleFilterChange}
                        periodOptions={periodOptions}
                        userOptions={cascadedUserOptions || userOptions}
                        serviceOptions={serviceOptions}
                        productCategoryOptions={productCategoryOptions}
                        standardOptions={standardOptions}
                        departmentOptions={departmentOptions}
                        branchOptions={branchOptions}
                        taggingOptions={taggingOptions}
                        canViewGlobal={canViewGlobal}
                        canViewDepartment={canViewDepartment}
                        canViewOwn={canViewOwn}
                        user={user}
                    />
                )}

                {/* Customer Balance Filter */}
                {activeTab === 'customer-balance' && (
                    <CustomerBalanceFilter
                        filters={customerBalanceFilters}
                        handleFilterChange={handleCustomerBalanceFilterChange}
                        periodOptions={periodOptions}
                        salesCreatorOptions={salesCreatorOptions}
                        serviceOptions={serviceOptions}
                        productCategoryOptions={productCategoryOptions}
                        standardOptions={standardOptions}
                        departmentOptions={departmentOptions}
                        paymentOptions={paymentOptions}
                        statusOptions={statusOptions}
                        branchOptions={branchOptions}
                        taggingOptions={taggingOptions}
                        canViewGlobal={canViewGlobal}
                        canViewDepartment={canViewDepartment}
                        canViewOwn={canViewOwn}
                        user={user}
                    />
                )}

                {/* Sales List Detail Filter */}
                {activeTab === 'sales-list-detail' && (
                    <SalesListDetailFilter
                        filters={salesListDetailFilters}
                        handleFilterChange={handleSalesListDetailFilterChange}
                        periodOptions={periodOptions}
                        salesCreatorOptions={salesCreatorOptions}
                        serviceOptions={serviceOptions}
                        productCategoryOptions={productCategoryOptions}
                        standardOptions={standardOptions}
                        departmentOptions={departmentOptions}
                        paymentOptions={paymentOptions}
                        branchOptions={branchOptions}
                        taggingOptions={taggingOptions}
                        canViewGlobal={canViewGlobal}
                        canViewDepartment={canViewDepartment}
                        canViewOwn={canViewOwn}
                        user={user}
                    />
                )}

                {/* Action Buttons */}
                <div className="d-flex gap-2 mt-4">
                    <button
                        className="btn btn-outline-primary flex-fill"
                        type="button"
                        onClick={handleResetFilter}
                    >
                        Reset
                    </button>
                    <button
                        className="btn btn-primary flex-fill"
                        type="button"
                        onClick={handleApplyFilter}
                    >
                        Apply
                    </button>
                </div>
            </div>
        </div>
    );
};

export default FilterOffcanvas;

